import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from 'react';
import { downloadUrl as download } from '../../../../../utils';
import { FormattedMessage } from 'react-intl-next';
import { ActionName } from '../../../../../constants';
import { messages } from '../../../../../messages';
import Action from '../action';
import { useFlexibleUiAnalyticsContext, useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import useInvokeClientAction from '../../../../../state/hooks/use-invoke-client-action';
import DownloadIcon from '@atlaskit/icon/glyph/download';
const DownloadAction = ({
  onClick: onClickCallback,
  ...props
}) => {
  var _context$actions;
  const context = useFlexibleUiContext();
  const analytics = useFlexibleUiAnalyticsContext();
  const invoke = useInvokeClientAction({
    analytics
  });
  const data = context === null || context === void 0 ? void 0 : (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[ActionName.DownloadAction];
  const onClick = useCallback(() => {
    if (data !== null && data !== void 0 && data.downloadUrl) {
      invoke({
        actionType: ActionName.DownloadAction,
        actionFn: async () => download(data === null || data === void 0 ? void 0 : data.downloadUrl),
        // These values have already been set in analytics context.
        // We only pass these here for ufo experience.
        display: analytics === null || analytics === void 0 ? void 0 : analytics.display,
        extensionKey: analytics === null || analytics === void 0 ? void 0 : analytics.extensionKey
      });
      if (onClickCallback) {
        onClickCallback();
      }
    }
  }, [analytics, data === null || data === void 0 ? void 0 : data.downloadUrl, invoke, onClickCallback]);
  const isStackItem = props.as === 'stack-item';
  const label = isStackItem ? messages.download_file : messages.download;
  const tooltipMessage = isStackItem ? messages.download_description : messages.download;
  return data ? /*#__PURE__*/React.createElement(Action, _extends({
    content: /*#__PURE__*/React.createElement(FormattedMessage, label),
    icon: /*#__PURE__*/React.createElement(DownloadIcon, {
      label: "Download"
    }),
    onClick: onClick,
    testId: "smart-action-download-action",
    tooltipMessage: /*#__PURE__*/React.createElement(FormattedMessage, tooltipMessage)
  }, data, props)) : null;
};
export default DownloadAction;